import { Card, CardBody, Col } from "reactstrap";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Image } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WithControl } from "../../../../Constant";
import { WITH_CONTROLS, WITH_CONTROL_DATA } from "../../../../Data/Bonus Ui/Carousel";

const WithControls = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={WithControl} span={WITH_CONTROLS} />
        <CardBody>
          <Swiper navigation={true} modules={[Navigation]}>
            {WITH_CONTROL_DATA.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={item.image} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithControls;
